import noop from "lib/noop"
import { useEffect, useLayoutEffect, useRef, useState } from "react"
import { Box } from "@mui/material"
import { getScreenPosition } from "lib/@components/get-screen-position"

const LAYOUT_SETTLE_DELAY = 250

export function MeasureYPosition({ onPosition = noop }) {
    const positionedItem = useRef()
    const positionRef = useRef(Number.POSITIVE_INFINITY)
    const [position, setPosition] = useState(Number.POSITIVE_INFINITY)

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useLayoutEffect(measurePosition)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(setupLayoutShiftMeasurement, [])
    useLayoutEffect(() => {
        onPosition(position)
    }, [onPosition, position])
    return <Box ref={positionedItem} />

    function setupLayoutShiftMeasurement() {
        window.addEventListener("resize", measurePosition)
        document.addEventListener("scroll", schedulePositionMeasurement, true)
        return cleanup
    }

    function cleanup() {
        window.removeEventListener("resize", measurePosition)
        document.removeEventListener("scroll", schedulePositionMeasurement, true)
    }

    function schedulePositionMeasurement() {
        measurePosition()
        window.requestAnimationFrame?.(measurePosition)
        window.setTimeout(measurePosition, LAYOUT_SETTLE_DELAY)
    }

    function measurePosition() {
        const nextPosition = positionedItem.current
            ? getScreenPosition(positionedItem.current).y
            : Number.POSITIVE_INFINITY
        if (positionRef.current === nextPosition) return
        positionRef.current = nextPosition
        setPosition(nextPosition)
    }
}
